import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<nav className="navbar !p-0 !m-0">
			<div className="container">
				<Link to="/" className="logo">
					<img
						src="/assets/images/trivnet.png"
						alt="Trivnet Services"
						className="!w-[80px] !h-[70px] !p-0 !m-0"
					/>
					{/* <span>Trivnet Services</span> */}
				</Link>

				<div className={`nav-links ${isOpen ? "active" : ""}`}>
					<Link to="/">Home</Link>
					<Link to="/services">Services</Link>
					<Link to="/about">About Us</Link>
					<Link to="/contact">Contact</Link>
				</div>

				<button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
					<span></span>
					<span></span>
					<span></span>
				</button>
			</div>
		</nav>
	);
};

export default Navbar;
